import axios from 'axios';
import { AGENT, BROKER, TEAM } from '@/Reporting/config/constants';

export default {
  namespaced: true,
  state: {
    teams: [],
    members: [],
    userType: '',
    error: null,
    isLoading: false,
  },
  mutations: {
    setFilterTeams(state, teamsList) {
      const teams = teamsList.teams.reduce((acc, val) => {
        const team = {
          id: val.id,
          name: val.name,
          target: teamsList.target,
        };
        return [...acc, team];
      }, []);
      state.teams = teams;
    },
    setFilterMembers(state, membersList) {
      const members = membersList.members.reduce((acc, val) => {
        const member = {
          id: val.id,
          name: `${val.first_name} ${val.last_name}`,
          target: AGENT,
          target_type: membersList.data_type,
        };
        return [...acc, member];
      }, []);

      state.members = members;
    },
    setUserType(state, userType) {
      state.userType = userType;
    },
    setFilterError(state, error) {
      state.error = error;
    },
    setFilterLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
  actions: {
    async getInfoForReportingFilter({ commit }) {
      commit('setFilterLoading', true);

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_EVENTS_API_BASE_URL}/reporting/brokers-teams`,
        );
        let teamsList = {};

        if (res.data.brokers) {
          teamsList = {
            teams: res.data.brokers,
            target: BROKER,
          };
        }
        if (res.data.teams) {
          teamsList = {
            teams: res.data.teams,
            target: TEAM,
          };
        }

        const membersList = {
          members: res.data.members,
          data_type: res.data.data_type,
        };

        const userType = res.data.data_type;

        commit('setFilterTeams', teamsList);
        commit('setFilterMembers', membersList);
        commit('setUserType', userType);
      } catch (error) {
        commit('setFilterError', error);
      } finally {
        commit('setFilterLoading', false);
      }
    },
  },
};
